import React, {useEffect, useRef, useState} from 'react';
import {UsePermissions} from "../../hooks/usePermissions";
import {Navigate} from "react-router";
import {ContainerTitleTable} from "../../components/Containers/ContainerTitleTable";
import {ContainerTable} from "../../components/Containers/ContainerTable";
import {UseLoader} from "../../hooks/useLoader";
import {Toast} from "primereact/toast";
import {AutoComplete} from "primereact/autocomplete";
import {ContainerGroupForm} from "../Containers/ContainerGroupForm";
import {useReactToPrint} from "react-to-print";
import {TabPanel, TabView} from "primereact/tabview";
import {traerInformeFondos} from "../../api/informes.service";
import {
    getAsociados,
    obtenerLiquidacionesPorCliente
} from "../../api/liquidacionDeduccion.service";
import {FondoDescripcion} from "./components/fondos/FondoDescripcion";
import {InformefondosTotal} from "./components/fondos/InformefondosTotal";


export const InformeFondos= () => {
    const [permisos] = UsePermissions();
    const [handleLoad] = UseLoader();
    const toast = useRef(null);
    const [clientes, setClientes] = useState([]);
    const [activeIndex, setActiveIndex] = useState(0);

    const [selectedcliente, setSelectedcliente] = useState({
        nombre: "",
        id: ""
    });
    const [FilteredCliente, setFilteredCliente] = useState(null);
    const [fechaLiquidaciones, setFechaLiquidaciones] = useState([]);
    const componentRef = useRef(null);

    /* variables info */

    const initParams = {
        cliente_id: '',
        fecha: ''
    };
    const [field, setField] = useState(initParams);
    const [dataFondo, setDataFondo] = useState([]);

    useEffect(() => {
        getAsociados().then(r => {
            if (r.estado !== 200) {
                return;
            }
            setClientes(r.data)
        }).catch(r => console.log(r))
        return () => {
            if (clientes.length > 0) {
                setClientes([]);
            }
        };
    }, []);


    //aqui se cambia el tema de las fechas
    const traerFechaLiquidacion = (id) => {
        setField({...field, cliente_id: id})
        obtenerLiquidacionesPorCliente(id, 'N').then(r => {
            if (r.estado !== 200) {
                setFechaLiquidaciones([]);
                toast.current?.show({severity: 'error', summary: 'Alerta', detail: r.mensaje, life: 3000});
                return;

            }
            setFechaLiquidaciones(r.data)
        }).catch(r => console.log(r))

    }

    const searchCliente = (event) => {
        setTimeout(() => {
            let _filteredCliente;
            if (!event.query.trim().length) {
                _filteredCliente = [...clientes];
            } else {
                _filteredCliente = clientes.filter((cliente) => {
                    return cliente.nombre.toLowerCase().startsWith(event.query.toLowerCase());
                });
            }

            setFilteredCliente(_filteredCliente);
        }, 250);
    }

    const itemTemplate = (item) => {
        return (
            <div className="flex ">
                <div className="ml-3">{item.nombre}</div>
            </div>
        );
    }

    const reloadInformesfondos = () => {
        if (field.cliente_id === "" ||field.fecha === '') {
            toast.current?.show({severity: 'error', summary: 'Alerta', detail: "Validar campos", life: 3000});
            return;
        }
        handleLoad(true)


        /** informes info */
        traerInformeFondos(field).then(r => {
            handleLoad(false)
            if (r.estado !== 200) {

                toast.current?.show({severity: 'error', summary: 'Alerta', detail: r.mensaje, life: 3000});
                return;
            }

            if (r.data.length>0) {
                setDataFondo( r.data);
            }

        }).catch(r => handleLoad(false))

    }

    const handlePrint = useReactToPrint({
        documentTitle: "Fondos Generados",
        content: () => componentRef.current,
        onBeforePrint:() => handleLoad(true),
        onAfterPrint: () => handleLoad(false),
    });

    const buscarLiquidaciones = (e) => {
        e.preventDefault();
        setActiveIndex(0);
        reloadInformesfondos();
    }


    return (

        <TabView  activeIndex={activeIndex} onTabChange={(e) => setActiveIndex(e.index)}>
            <TabPanel   header="Informe fondos por asociado">
                <ContainerTable>
                    {permisos.consultar ?  <div className="container-relative">
                        <Toast ref={toast}/>
                        {dataFondo.length > 0 && <div className="my-4 lg:w-4/12 m-auto ">
                            <button
                                className="secundary-color-btn btn w-full"
                                type="button"
                                onClick={handlePrint}
                            >
                                Imprimir
                            </button>
                        </div>}
                        <ContainerTable>
                            <div className="px-2">
                                <div className=" flex flex-wrap items-center  p-4 primary-color">
                                    {permisos.consultar === 1 && clientes.length > 0 ?
                                        <div className=" mt-2 relative lg:w-4/12 px-4">
                                            <AutoComplete value={selectedcliente} suggestions={FilteredCliente}
                                                          style={{"width": "100%"}}
                                                          completeMethod={searchCliente}
                                                          placeholder="Buscador de asociados"
                                                          size="30"
                                                          field="nombre" dropdown itemTemplate={itemTemplate}
                                                          onSelect={(e) => traerFechaLiquidacion(e.value.id)}
                                                          onChange={(e) => setSelectedcliente(e.value)}/>
                                        </div>
                                        : ""}
                                    <div className=" mt-2 relative lg:w-8/12 px-4">
                                        <form onSubmit={buscarLiquidaciones}>
                                            <div className="row">

                                                {fechaLiquidaciones.length > 0 && <ContainerGroupForm width="lg:w-3/12">
                                                    <label
                                                        className="label-form text-white"
                                                        htmlFor="fecha"
                                                    >
                                                        Fecha liquidación *
                                                    </label>
                                                    <select value={field.fecha} name="periodo"
                                                            className="form-input"
                                                            onChange={(e) => setField({...field, fecha: e.target.value})}
                                                            id="fecha">
                                                        <option value="">...</option>
                                                        {fechaLiquidaciones.map((p, i) => <option key={i}
                                                                                                  value={p.fecha}>{p.fecha}</option>)}
                                                    </select>

                                                </ContainerGroupForm>}
                                                <ContainerGroupForm width="lg:w-4/12">
                                                    <div className="mt-6 relative w-full px-4">
                                                        <button
                                                            className="warning-color-btn btn w-full"
                                                            type="submit"
                                                        >
                                                            Buscar
                                                        </button>
                                                    </div>
                                                </ContainerGroupForm>
                                            </div>
                                        </form>

                                    </div>

                                </div>

                            </div>

                            {dataFondo.length > 0 &&  <FondoDescripcion
                                ref={componentRef}
                                datafondo={dataFondo}
                            />}
                        </ContainerTable>

                    </div>: <Navigate to="/home"/>}
                </ContainerTable>
            </TabPanel>
            <TabPanel header="Informe de fondos generados">
                <ContainerTable>
                    <ContainerTable>
                        {permisos.consultar? <InformefondosTotal /> : <Navigate to="/home" />}
                    </ContainerTable>

                </ContainerTable>
            </TabPanel>

        </TabView>


    );
}
